import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';
import { PaymentsStatisticsQueryParams } from 'entities/Warehouse';

export const transformPaymentsStatisticsFilters = ({
  selectedWarehouses,
  startDate,
  endDate,
}: TableFilterType): PaymentsStatisticsQueryParams => {
  const warehouseId = selectedWarehouses?.value?.length ? selectedWarehouses.value : undefined;

  return {
    warehouseId,
    startDate: getFilterServerFormatDate(startDate?.value),
    endDate: getFilterServerFormatDate(endDate?.value),
  };
};
